const reOrderParagraphContent = `
  <div className="header2Class">
    <p>
      <input type="text" className="optionClass" /><br>
      <input type="text" className="optionClass" /><br>
      <input type="text" className="optionClass" /><br>
      <input type="text" className="optionClass" /><br>
      <input type="text" className="optionClass" />
    </p>
  </div>
`;

export default reOrderParagraphContent;
